import {
    APPTOOLBAR_RESET_APP_STATE,
    ATTEMPT_TO_SAVE_CURRENT_PROJECT,
    CONVERT_TO_MULTIBED_PROJECT,
    PROJECT_SET_STATUS,
    PROJECTS_CRUD_SET_CURRENT_PROJECT,
    PROJECTS_CRUD_SET_INFORMATION,
    PROJECTS_CRUD_RESTORE_STATE,
} from "../lib/types";
import Project from "../lib/project";
import produce from "immer";
import { createSelector } from "reselect";

/* Resolved lazily: store.js -> reducers/index.js -> this module, so a top-level
   store import leaves that cycle half-initialised depending on entry point. */
const getStore = () => require("../store").default;
const initialState = {
    // this is the information of an unsaved project
    projectInfo: {
        projectName: "",
        engineer: "",
        city: "",
        state: "",
        country: "",
        region: "",
        language: "",
        isMultiBedProject: false,
    },
    // this is the actual project in the backend(lib Project instance)
    project: null,
    runSaveProject: false,
};

export let ProjectReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case PROJECT_SET_STATUS:
            let project = new Project();
            const draftProject = produce(project, projectDraft => {
                projectDraft.id = state.project.id;
                projectDraft.projectName = state.project.projectName;
                projectDraft.engineer = state.project.engineer;
                projectDraft.city = state.project.city;
                projectDraft.state = state.project.state;
                projectDraft.country = state.project.country;
                projectDraft.region = state.project.region;
                projectDraft.language = state.project.language;
                projectDraft.createdDate = state.project.createdDate;
                projectDraft.statusDate = state.project.statusDate;
                projectDraft.editedDate = state.project.editedDate;
                projectDraft.processingStatus = (
                    action.payload.workItemStatus
                    || action.payload.processingStatus
                    || state.project.processingStatus
                );
                projectDraft.bomFileUrl = state.project.bomFileUrl;
                projectDraft.active = state.project.id;
                projectDraft.workItemId = state.project.active;
                projectDraft.inputFileURL = state.project.id; //inputFileURL
                projectDraft.outputFileURL = state.project.inputFileURL; //outputFileURL
                projectDraft.projectType = state.project.projectType;
                projectDraft.outputFileURLPipe = state.project.outputFileURLPipe;
                projectDraft.bomFileUrlPipe = state.project.bomFileUrlPipe;
                projectDraft.isMultiBedProject = state.project.isMultiBedProject;
            });
            return {
                ...state,
                project: draftProject,
            };

        case PROJECTS_CRUD_SET_INFORMATION:
            return {
                ...state,
                projectInfo: action.payload,
            };

        case PROJECTS_CRUD_SET_CURRENT_PROJECT:
            const stateDraft = produce(state, draft => {
                try {
                    draft["project"] = { ...action.payload };
                } catch (e) {
                    console.error(`PROJECTS_CRUD_SET_CURRENT_PROJECT stateDraft :: ${e.message}`);
                }
            });
            return {
                ...stateDraft,
            };

        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        case ATTEMPT_TO_SAVE_CURRENT_PROJECT:
            return {
                ...state,
                runSaveProject: action.payload,
            };

        case CONVERT_TO_MULTIBED_PROJECT:
            let stateProjectDraft;
            if (state.project) {
                stateProjectDraft = produce(state, draft => {
                        draft["project"].isMultiBedProject = true;
                        draft["projectInfo"].isMultiBedProject = true;
                    },
                );
            } else {
                stateProjectDraft = produce(state, draft => {
                        draft["projectInfo"].isMultiBedProject = true;
                    },
                );
            }
            return {
                ...state,
                ...stateProjectDraft,
            };
        default:
            return state;
    }
};

// SELECTORS
const getProject = state => state.project;
const ProjectSelectors = {
    isMultiBedProject: () => {
        try {
            const getIsMultiBedProject = createSelector(
                [getProject],
                ( project ) => {
                    return ( project.project && project.project.isMultiBedProject )
                        ? project.project.isMultiBedProject
                        : project.projectInfo.isMultiBedProject;
                });
            return getIsMultiBedProject(getStore().getState());
        } catch (error) {
            console.error(`ProjectSelectors.isMultiBedProject() :: ${error.message}`);
        }
    },
};

export default ProjectSelectors;



// WEBPACK FOOTER //
// ./src/reducers/project-reducer.js